import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-68e4d06c")

_pushScopeId("data-v-68e4d06c")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("You are now under demo account")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Switch to Live")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")
  const _component_t = _resolveComponent("t")
  const _component_AccountRelated = _resolveComponent("AccountRelated")

  return (_openBlock(), _createBlock(_component_AccountRelated, { "use-in-demo": "" }, {
    default: _withId(() => [
      _createVNode("div", _mergeProps({ class: "acc-tip f-sm py-8 px-16 df-middle" }, _ctx.$attrs, { style: {"display":"none"} }), [
        _createVNode(_component_Icon, {
          name: "demo-account",
          sm: ""
        }),
        _createVNode(_component_t, {
          path: "trade_10",
          class: "flex-1 t-left"
        }, {
          default: _withId(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_t, {
          as: "button",
          path: "symbol_81",
          class: "f-xs br-sm",
          onClick: _ctx.toLive
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"])
      ], 16)
    ]),
    _: 1
  }))
})